import React from "react";
import "../App.css";
import google from "../assets/google_store.png";
import apple from "../assets/apple_store.png";
import pcm from "../assets/pcm.jpeg";

const Download = () => {
  // reminder: do app icon as well
  const openPlayLink = () => {
    localStorage.setItem("flag", "false");
    window.open("https://play.google.com/store/apps/details?id=com.posturecoreandmore", "_self");
  };

  const openAppleLink = () => {
    localStorage.setItem("flag", "false");
    window.open("https://apps.apple.com/us/app/posturecoreandmore/id1585601439", "_self");
  };

  return (
    <div
      className="app"
      style={{ backgroundColor: "black", position: "absolute", top: 0 }}
    >
      <div
        style={{
          backgroundColor: "white",
          borderRadius: 10,
          alignItems: "center",
          justifyContent: "center",
          display: "flex",
          flexDirection: "column",
          paddingLeft: 40,
          paddingRight: 40,
          paddingBottom: 40,
        }}
      >
        <img style={{ width: 300, height: 300 }} src={pcm} />

        <button
          onClick={openPlayLink}
          style={{
            width: 350,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            height: 80,
            backgroundColor: "#f2f2f2",
            borderRadius: 10,
            border: "1px solid lightgray",
          }}
        >
          <img style={{ width: 55, height: 55 }} src={google} />
          <div style={{ fontSize: 18, marginLeft: 10 }}>
            Download from Google Store
          </div>
        </button>

        <button
          onClick={openAppleLink}
          style={{
            width: 350,
            marginTop: 15,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            height: 80,
            backgroundColor: "#f2f2f2",
            borderRadius: 10,
            border: "1px solid lightgray",
          }}
        >
          <img style={{ width: 60, height: 60 }} src={apple} />
          <div style={{ fontSize: 18, marginLeft: 10 }}>
            Download from Apple Store
          </div>
        </button>
      </div>
    </div>
  );
};

export default Download;
